import React, { PropsWithChildren, useState } from "react";

import ExamLockerContext from "components/ExamLockerContext";

interface IProps {
  recordId: string;
  onUnlock: () => void;
}

const LockableRow = (props: PropsWithChildren<IProps>) => {
  const { children, recordId, onUnlock } = props;
  const [isLocked, setIsLocked] = useState<boolean>(false);

  const handlePullSuccess = result => {
    if (isLocked && !result.isLocked) {
      onUnlock();
    }
    setIsLocked(Boolean(result.isLocked));
  };

  return (
    <ExamLockerContext
      recordId={recordId}
      refetchInterval={30000}
      countdown={false}
      onPullSuccess={handlePullSuccess}
    >
      {children}
    </ExamLockerContext>
  );
};

export default LockableRow;
